// extracted by mini-css-extract-plugin
export default {"tag":"Tags_tag__sMUYw","ux":"Tags_ux__oCFxi","web":"Tags_web__ix8kb","front":"Tags_front__WI7-O","graphic":"Tags_graphic__cBddC","branding":"Tags_branding__UYWOh"};